import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { listingPath } from "../../shared/market";
import { ErrorMessage, Loading } from "../components/StatusMessage";
import { useI18n } from "../i18n/I18nProvider";
import { useAsync } from "../lib/useAsync";
import { marketApi } from "./api";

/**
 * /mercado/:id — a listing's old address (emails, cart and order lines, shares): a listing is an offer on
 * its card's page now, so this goes there with that offer marked. The server answers a full load with a
 * 301; this is for links followed inside the app.
 */
export function ListingRedirect() {
  const { id } = useParams();
  const { t } = useI18n();
  const { search, state } = useLocation();
  const navigate = useNavigate();
  const listing = Number(id);
  const where = useAsync((signal) => marketApi.listingProduct(listing, signal), [listing]);
  useEffect(() => {
    if (!where.data) return;
    const to = new URL(listingPath({ id: listing, productSlug: where.data.productSlug }), "http://x");
    for (const [k, v] of new URLSearchParams(search)) if (!to.searchParams.has(k)) to.searchParams.append(k, v);
    navigate(`${to.pathname}${to.search}`, { replace: true, state });
  }, [where.data, listing, search, state, navigate]);
  if (where.error) return <ErrorMessage message={t("mkt.listingNotFound")} />;
  return <Loading />;
}
